import { get, set } from "lodash";

import { BUSINESS_RESOURCE_FIELDS, EXPRESSION_SCHEMAS, ITEM_SCHEMAS, MANIFESTATION_SCHEMAS, MUSEUM_WORK_SCHEMAS, PHYSICAL_MUSEUM_ITEM_SCHEMAS, PHYSICAL_MUSEUM_MANIFESTATION_SCHEMAS, SearchResult, WORK_SCHEMAS, Wemi } from "@skinsoft/types";
import { searchResultSelectors } from "@skinsoft/search-data-store";

export function searchResultToWemi(searchResult: SearchResult): Wemi {
    let itemSchemas = ITEM_SCHEMAS
    let manifestationSchemas = MANIFESTATION_SCHEMAS
    let expressionSchema = EXPRESSION_SCHEMAS
    let workSchemas = WORK_SCHEMAS

    const itemType = searchResultSelectors.itemType(searchResult)
    const manifestationType = searchResultSelectors.manifestationType(searchResult)
    const expressionType = searchResultSelectors.expressionType(searchResult)
    const workType = searchResultSelectors.workType(searchResult)

    switch(itemType?.toLowerCase()) {
        case 'physicalmuseumitem':
            itemSchemas = PHYSICAL_MUSEUM_ITEM_SCHEMAS
            break
    }

    switch(manifestationType?.toLowerCase()) {
        case 'physicalmuseummanifestation':
            manifestationSchemas = PHYSICAL_MUSEUM_MANIFESTATION_SCHEMAS
            break
    }

    switch(workType?.toLowerCase()) {
        case 'museumwork':
            workSchemas = MUSEUM_WORK_SCHEMAS
            break
    }

    itemSchemas = itemSchemas.concat(BUSINESS_RESOURCE_FIELDS)

    let wemi: any = {
        item: {},
        manifestation: {},
        work: {},
        expression: {},
    }

    for(const schema of itemSchemas) {
        const value = get(searchResult, `${schema}`)
        set(wemi.item, `${schema}`, value)
    }

    for(const schema of manifestationSchemas) {
        const value = get(searchResult, `${schema}`)
        set(wemi.manifestation, `${schema}`, value)
    }

    for(const schema of expressionSchema) {
        const value = get(searchResult, `${schema}`)
        set(wemi.expression, `${schema}`, value)
    }

    for(const schema of workSchemas) {
        const value = get(searchResult, `${schema}`)
        set(wemi.work, `${schema}`, value)
    }

    const itemId = searchResultSelectors.itemId(searchResult)
    const manifestationId = searchResultSelectors.manifestationId(searchResult)
    const expressionId = searchResultSelectors.expressionId(searchResult)
    const workId = searchResultSelectors.workId(searchResult)

    if(itemId) {
        wemi.item.id = itemId
    }
    if(manifestationId) {
        wemi.manifestation.id = manifestationId
    }
    if(expressionId) {
        wemi.expression.id = expressionId
    }
    if(workId) {
        wemi.work.id = workId
    }

    if(!wemi.item.type) {
        wemi.item.type = searchResult.entityType
    }

    return wemi as Wemi
}